// Edit products here. All products share the global sizes/prices in src/config/pricing.js
// To add a product, copy a block and update the fields.
// To change images, drop files in public/products/ and set image: "/products/your-file.webp"

export const CATEGORIES = [
  'All',
  'Signature Oud',
  'Sweet & Warm',
  'Dark & Bold',
  'Soft & Clean',
  'Fresh & Bright',
  'Floral & Elegant',
  'Gift Ready',
];

export const PRODUCTS = [
  { id: 'aurora-mist', name: 'Aurora Mist', category: 'Fresh & Bright',
    profile: 'Fresh oud, citrus, amber, leather, musk',
    description: 'A bright aromatic opening with citrus, soft herbs and warm oud, settling into leather, musk and smoky vetiver.',
    bestFor: 'Daily wear, clean luxury, first impressions',
    featured: true, giftReady: true,
    notes: ['fresh', 'citrus', 'oud', 'amber', 'leather', 'musk', 'clean'],
    image: '/products/aurora-mist.webp' },

  { id: 'malik-gold', name: 'Malik Gold', category: 'Sweet & Warm',
    profile: 'Citrus, Mediterranean fruits, vanilla, amber, white musk',
    description: 'Radiant citrus and soft fruits wrapped in creamy vanilla, golden amber and clean musk.',
    bestFor: 'Everyday confidence, gifting, warm weather',
    featured: true, giftReady: true,
    notes: ['citrus', 'fruit', 'vanilla', 'amber', 'musk', 'sweet'],
    image: '/products/malik-gold.webp' },

  { id: 'princess', name: 'Princess', category: 'Floral & Elegant',
    profile: 'Red berries, dry woods, lily, vanilla, amber, musk',
    description: 'A soft fruity floral scent with smooth vanilla and a warm woody musk finish.',
    bestFor: 'Feminine gifting, soft elegance, daily wear',
    featured: true, giftReady: true,
    notes: ['berry', 'floral', 'lily', 'vanilla', 'amber', 'musk', 'feminine'],
    image: '/products/princess.webp' },

  { id: 'mufasa', name: 'Mufasa', category: 'Signature Oud',
    profile: 'Raspberry, oud, saffron, ambergris, sandalwood',
    description: 'A bold oud blend with sweet raspberry, saffron warmth and a smooth woody base.',
    bestFor: 'Statement wear, evenings, strong presence',
    featured: true, giftReady: true,
    notes: ['oud', 'raspberry', 'saffron', 'sandalwood', 'bold'],
    image: '/products/mufasa.webp' },

  { id: 'sakura', name: 'Sakura', category: 'Fresh & Bright',
    profile: 'Bergamot, passion fruit, peach, jasmine, caramel, white musk',
    description: 'Fruity, bright and smooth with soft florals, caramel warmth and a clean musky finish.',
    bestFor: 'Daytime, soft sweetness, casual luxury',
    featured: false, giftReady: true,
    notes: ['bergamot', 'peach', 'jasmine', 'caramel', 'musk', 'fresh'],
    image: '/products/sakura.webp' },

  { id: 'black-cherry-noir', name: 'Black Cherry Noir', category: 'Dark & Bold',
    profile: 'Dark cherry, saffron, apricot, leather, smoked woods',
    description: 'A rich cherry scent with smoky woods, soft leather and a dark luxurious dry down.',
    bestFor: 'Date night, evenings, bold impressions',
    featured: true, giftReady: true,
    notes: ['cherry', 'saffron', 'leather', 'smoke', 'wood', 'dark'],
    image: '/products/black-cherry-noir.webp' },

  { id: 'tonka-oud', name: 'Tonka Oud', category: 'Signature Oud',
    profile: 'Bergamot, saffron, rose, oud, amber, tonka, white musk',
    description: 'Smooth oud and rose with amber warmth, tonka sweetness and a refined musky base.',
    bestFor: 'Luxury oud lovers, evening wear, gifting',
    featured: true, giftReady: true,
    notes: ['oud', 'rose', 'saffron', 'tonka', 'amber', 'musk'],
    image: '/products/tonka-oud.webp' },

  { id: 'adventure', name: 'Adventure', category: 'Signature Oud',
    profile: 'Oud wood, raspberry, saffron, incense, rose, leather, amberwood',
    description: 'A deep adventurous oud with smoky incense, soft rose, leather and sweet resinous warmth.',
    bestFor: 'Bold wear, cold evenings, statement scent',
    featured: false, giftReady: true,
    notes: ['oud', 'incense', 'rose', 'leather', 'amber', 'bold'],
    image: '/products/adventure.webp' },

  { id: 'shadow-man', name: 'Shadow Man', category: 'Dark & Bold',
    profile: 'Black orchid accord, spice, dark florals, chocolate, patchouli, incense',
    description: 'Dark, smooth and mysterious with rich florals, spice, amber and smoky sweetness.',
    bestFor: 'Night wear, masculine elegance, luxury presence',
    featured: true, giftReady: true,
    notes: ['orchid', 'spice', 'chocolate', 'patchouli', 'incense', 'dark'],
    image: '/products/shadow-man.webp' },

  { id: 'lamia', name: 'Lamia', category: 'Floral & Elegant',
    profile: 'Peach, apple blossom, pineapple blossom, rose, musk, patchouli',
    description: 'A soft fruity floral scent with a musky, lightly woody finish.',
    bestFor: 'Feminine wear, daytime, sweet gifting',
    featured: false, giftReady: true,
    notes: ['peach', 'blossom', 'rose', 'musk', 'floral'],
    image: '/products/lamia.webp' },

  { id: 'layali', name: 'Layali', category: 'Signature Oud',
    profile: 'Saffron, nutmeg, oud, rose, amber, musk, sandalwood',
    description: 'Warm saffron and rose wrapped around oud, amber and creamy sandalwood.',
    bestFor: 'Traditional oud feel, evenings, elegant occasions',
    featured: false, giftReady: true,
    notes: ['saffron', 'oud', 'rose', 'amber', 'sandalwood'],
    image: '/products/layali.webp' },

  { id: 'soft-powder', name: 'Soft Powder', category: 'Soft & Clean',
    profile: 'Aldehydes, iris, violet, heliotrope, white musk, vanilla',
    description: 'Clean, powdery and soft with creamy florals, white musk and gentle sweetness.',
    bestFor: 'Clean scent lovers, everyday wear, soft luxury',
    featured: false, giftReady: true,
    notes: ['iris', 'violet', 'powder', 'musk', 'vanilla', 'clean'],
    image: '/products/soft-powder.webp' },

  { id: 'vanilla-musk', name: 'Vanilla Musk', category: 'Soft & Clean',
    profile: 'Jasmine, rose, ylang ylang, violet, white musk, amber, vanilla',
    description: 'Smooth white florals with soft musk, amber and a warm vanilla finish.',
    bestFor: 'Soft feminine scent, clean warmth, gifting',
    featured: false, giftReady: true,
    notes: ['jasmine', 'rose', 'ylang', 'musk', 'amber', 'vanilla'],
    image: '/products/vanilla-musk.webp' },

  { id: 'vanilla-tempest', name: 'Vanilla Tempest', category: 'Sweet & Warm',
    profile: 'Mandarin, peach, vanilla, musk, amber, caramel',
    description: 'Fruity sweetness with creamy vanilla, amber and a soft caramel musk dry down.',
    bestFor: 'Sweet scent lovers, daily wear, cosy evenings',
    featured: false, giftReady: true,
    notes: ['mandarin', 'peach', 'vanilla', 'caramel', 'amber', 'sweet'],
    image: '/products/vanilla-tempest.webp' },

  { id: 'nadeen', name: 'Nadeen', category: 'Sweet & Warm',
    profile: 'Blackcurrant, pear, iris, jasmine, praline, vanilla, tonka',
    description: 'A sweet elegant fragrance with juicy fruit, soft florals and a creamy praline vanilla base.',
    bestFor: 'Feminine luxury, gifting, evenings',
    featured: false, giftReady: true,
    notes: ['blackcurrant', 'pear', 'jasmine', 'praline', 'vanilla', 'tonka'],
    image: '/products/nadeen.webp' },

  { id: 'star-fall', name: 'Star Fall', category: 'Sweet & Warm',
    profile: 'Litchi, raspberry, violet leaf, white rose, peony, jasmine, vanilla, musk',
    description: 'A soft fruity floral blend with rose, peony, vanilla and clean musk.',
    bestFor: 'Daytime, romantic scent, gifting',
    featured: false, giftReady: true,
    notes: ['litchi', 'raspberry', 'rose', 'peony', 'jasmine', 'vanilla'],
    image: '/products/star-fall.webp' },

  { id: 'timber-oud', name: 'Timber Oud', category: 'Signature Oud',
    profile: 'Cardamom, pink pepper, oud, sandalwood, patchouli, vetiver, amber',
    description: 'A woody oud with spice, sandalwood, earthy vetiver and warm amber sweetness.',
    bestFor: 'Oud lovers, mature scent, formal wear',
    featured: false, giftReady: true,
    notes: ['cardamom', 'pepper', 'oud', 'sandalwood', 'vetiver', 'wood'],
    image: '/products/timber-oud.webp' },

  { id: 'victorium', name: 'Victorium', category: 'Fresh & Bright',
    profile: 'Bergamot, blackcurrant, apple, lemon, pineapple, birch, oakmoss, musk',
    description: 'Fresh, fruity and woody with a confident clean finish.',
    bestFor: 'Everyday masculine wear, fresh confidence, summer evenings',
    featured: false, giftReady: true,
    notes: ['bergamot', 'apple', 'lemon', 'pineapple', 'birch', 'oakmoss', 'fresh'],
    image: '/products/victorium.webp' },

  { id: 'black-panther', name: 'Black Panther', category: 'Dark & Bold',
    profile: 'Pear, pink pepper, coffee, jasmine, almond, vanilla, patchouli',
    description: 'Dark coffee sweetness with florals, almond, vanilla and smooth woods.',
    bestFor: 'Date night, evening wear, sweet dark scent',
    featured: false, giftReady: true,
    notes: ['pear', 'coffee', 'jasmine', 'almond', 'vanilla', 'patchouli', 'dark'],
    image: '/products/black-panther.webp' },

  { id: 'fortune-musk', name: 'Fortune Musk', category: 'Soft & Clean',
    profile: 'Aldehydic spice, rose, musk, amber, oud woods',
    description: 'Clean musk and soft rose with warm amber and a subtle oud woody base.',
    bestFor: 'Clean luxury, daily wear, soft projection',
    featured: false, giftReady: true,
    notes: ['rose', 'musk', 'amber', 'oud', 'clean'],
    image: '/products/fortune-musk.webp' },

  { id: 'noble-woman', name: 'Noble Woman', category: 'Floral & Elegant',
    profile: 'Almond, coffee, bergamot, tuberose, jasmine, rose, tonka, cacao, vanilla',
    description: 'A rich feminine blend with creamy florals, coffee, vanilla, cacao and soft woods.',
    bestFor: 'Elegant evenings, gifting, feminine statement scent',
    featured: false, giftReady: true,
    notes: ['almond', 'coffee', 'tuberose', 'jasmine', 'rose', 'cacao', 'vanilla'],
    image: '/products/noble-woman.webp' },

  { id: 'dolce-limone', name: 'Dolce Limone', category: 'Sweet & Warm',
    profile: 'Raspberry, orange, bergamot, strawberry, caramel, vanilla, musk',
    description: 'Playful sweetness with red fruits, citrus, caramel, vanilla and soft musk.',
    bestFor: 'Sweet scent lovers, younger buyers, gifts',
    featured: false, giftReady: true,
    notes: ['raspberry', 'orange', 'strawberry', 'caramel', 'vanilla', 'sweet'],
    image: '/products/dolce-limone.webp' },

  { id: 'white-musk', name: 'White Musk', category: 'Soft & Clean',
    profile: 'Lily, ylang ylang, jasmine, rose, violet, white musk, amber, vetiver, vanilla',
    description: 'Clean white musk with soft florals, warm amber and a smooth powdery finish.',
    bestFor: 'Everyday wear, layering, clean scent lovers',
    featured: false, giftReady: true,
    notes: ['lily', 'ylang', 'jasmine', 'rose', 'musk', 'amber', 'vanilla'],
    image: '/products/white-musk.webp' },

  { id: 'choulli-oud', name: 'Choulli Oud', category: 'Signature Oud',
    profile: 'Lemon, bergamot, rhum, neroli, sage, patchouli, benzoin, musk, vanilla, dry wood',
    description: 'Bright citrus and herbal warmth over patchouli, dry woods, vanilla and musk.',
    bestFor: 'Unique oud lovers, mature wear, evening scent',
    featured: false, giftReady: true,
    notes: ['lemon', 'neroli', 'sage', 'patchouli', 'benzoin', 'vanilla', 'wood'],
    image: '/products/choulli-oud.webp' },

  { id: 'arabian-rose', name: 'Arabian Rose', category: 'Floral & Elegant',
    profile: 'Saffron, Damask rose, patchouli, oud, amber',
    description: 'A rich rose oud with saffron warmth, patchouli depth and amber smoothness.',
    bestFor: 'Traditional luxury, gifting, formal occasions',
    featured: false, giftReady: true,
    notes: ['saffron', 'rose', 'patchouli', 'oud', 'amber'],
    image: '/products/arabian-rose.webp' },

  { id: 'sanctum-oud', name: 'Sanctum Oud', category: 'Signature Oud',
    profile: 'Saffron, apricot, citrus, Taif rose, patchouli, jasmine, caramel, oud, sandalwood, amber',
    description: 'A luxurious rose oud with fruit, caramel warmth, soft florals and a deep amber base.',
    bestFor: 'Special occasions, oud collectors, premium gifting',
    featured: false, giftReady: true,
    notes: ['saffron', 'apricot', 'rose', 'jasmine', 'caramel', 'oud', 'sandalwood'],
    image: '/products/sanctum-oud.webp' },

  { id: 'ruby-oud', name: 'Ruby Oud', category: 'Signature Oud',
    profile: 'Raspberry, pear, saffron, Bulgarian rose, orange blossom, oud, patchouli, amber, musk',
    description: 'Fruity rose oud with saffron, amber and a smooth musky finish.',
    bestFor: 'Statement gifting, evenings, sweet oud lovers',
    featured: false, giftReady: true,
    notes: ['raspberry', 'pear', 'saffron', 'rose', 'orange', 'oud', 'amber'],
    image: '/products/ruby-oud.webp' },

  { id: 'jazmine', name: 'Jazmine', category: 'Floral & Elegant',
    profile: 'Jasmine, sandalwood, soft musk, subtle amber',
    description: 'A smooth jasmine focused scent with creamy sandalwood and soft musky warmth.',
    bestFor: 'Floral lovers, daily elegance, layering',
    featured: false, giftReady: true,
    notes: ['jasmine', 'sandalwood', 'musk', 'amber', 'floral'],
    image: '/products/jazmine.webp' },

  { id: 'the-elect', name: 'The Elect', category: 'Dark & Bold',
    profile: 'Chestnut, sugar, lavender, sage, vanilla, smoke',
    description: 'Warm, sweet and smoky with lavender, sage and a vanilla dry down.',
    bestFor: 'Cold evenings, masculine sweetness, date night',
    featured: false, giftReady: true,
    notes: ['chestnut', 'sugar', 'lavender', 'sage', 'vanilla', 'smoke'],
    image: '/products/the-elect.webp' },

  { id: 'white-oud', name: 'White Oud', category: 'Signature Oud',
    profile: 'Vanilla, white pepper, soft spices, creamy woods, subtle oud',
    description: 'A smooth creamy oud with soft spice, vanilla and polished woods.',
    bestFor: 'First time oud buyers, everyday luxury, gifting',
    featured: false, giftReady: true,
    notes: ['vanilla', 'pepper', 'spice', 'wood', 'oud', 'creamy'],
    image: '/products/white-oud.webp' },

  { id: 'velorien', name: 'Velorien', category: 'Floral & Elegant',
    profile: 'Smooth floral, amber, musk, soft woods',
    description: 'Elegant and polished with soft florals, warm amber and a clean musky finish.',
    bestFor: 'Feminine gifting, daily elegance, soft luxury',
    featured: false, giftReady: true,
    notes: ['floral', 'amber', 'musk', 'wood', 'elegant'],
    image: '/products/velorien.webp' },

  { id: 'pink-musk', name: 'Pink Musk', category: 'Soft & Clean',
    profile: 'Pink florals, clean musk, soft sweetness',
    description: 'A gentle clean musk with soft pink florals and a delicate sweet finish.',
    bestFor: 'Everyday wear, soft feminine scent, layering',
    featured: false, giftReady: true,
    notes: ['pink', 'floral', 'musk', 'sweet', 'clean'],
    image: '/products/pink-musk.webp' },

  { id: 'dominion', name: 'Dominion', category: 'Fresh & Bright',
    profile: 'Fresh citrus, aromatic spice, clean woods, amber',
    description: 'Fresh, bold and clean with a masculine aromatic edge and warm woody base.',
    bestFor: 'Daily confidence, gym to evening, masculine wear',
    featured: false, giftReady: true,
    notes: ['citrus', 'spice', 'wood', 'amber', 'fresh', 'masculine'],
    image: '/products/dominion.webp' },

  { id: 'fortitude', name: 'Fortitude', category: 'Fresh & Bright',
    profile: 'Fresh fruit, aquatic notes, amber woods, musk',
    description: 'Bright, fresh and confident with a smooth amber musky finish.',
    bestFor: 'Everyday wear, summer, clean masculine scent',
    featured: false, giftReady: true,
    notes: ['fruit', 'aquatic', 'amber', 'wood', 'musk', 'fresh'],
    image: '/products/fortitude.webp' },

  { id: 'black-tobacco', name: 'Black Tobacco', category: 'Dark & Bold',
    profile: 'Dark tobacco, spice, dry woods, amber',
    description: 'A deep tobacco scent with spice, woods and warm amber depth.',
    bestFor: 'Mature wear, cold nights, strong presence',
    featured: false, giftReady: true,
    notes: ['tobacco', 'spice', 'wood', 'amber', 'dark'],
    image: '/products/black-tobacco.webp' },

  { id: 'golden-leaf-vanilla', name: 'Golden Leaf Vanilla', category: 'Sweet & Warm',
    profile: 'Tobacco leaf, vanilla, spice, amber, woods',
    description: 'Smooth tobacco and creamy vanilla with warm spice and soft woods.',
    bestFor: 'Winter, date night, luxury sweetness',
    featured: false, giftReady: true,
    notes: ['tobacco', 'vanilla', 'spice', 'amber', 'wood', 'sweet'],
    image: '/products/golden-leaf-vanilla.webp' },

  { id: 'golden-boy', name: 'Golden Boy', category: 'Sweet & Warm',
    profile: 'Sweet fruit, amber, musk, soft woods',
    description: 'Warm, sweet and smooth with a golden amber musk finish.',
    bestFor: 'Daily wear, youthful luxury, gifting',
    featured: false, giftReady: true,
    notes: ['fruit', 'amber', 'musk', 'wood', 'sweet'],
    image: '/products/golden-boy.webp' },

  { id: 'legacy-oud', name: 'Legacy Oud', category: 'Signature Oud',
    profile: 'Amber, oud, resin, woods, musk',
    description: 'A refined amber oud with resinous warmth and a smooth woody base.',
    bestFor: 'Classic oud lovers, formal wear, mature scent',
    featured: false, giftReady: true,
    notes: ['amber', 'oud', 'resin', 'wood', 'musk'],
    image: '/products/legacy-oud.webp' },

  { id: 'banana-oud', name: 'Banana Oud', category: 'Sweet & Warm',
    profile: 'Banana sweetness, oud, vanilla, amber',
    description: 'A playful sweet oud with creamy banana, vanilla and warm amber depth.',
    bestFor: 'Unique scent lovers, casual wear, sweet oud fans',
    featured: false, giftReady: true,
    notes: ['banana', 'oud', 'vanilla', 'amber', 'sweet'],
    image: '/products/banana-oud.webp' },

  { id: 'lavender-oud', name: 'Lavender Oud', category: 'Signature Oud',
    profile: 'Lavender, oud, soft spice, amber, woods',
    description: 'Calm lavender blended with oud, soft spices and warm woods.',
    bestFor: 'Relaxed evenings, clean oud, mature gifting',
    featured: false, giftReady: true,
    notes: ['lavender', 'oud', 'spice', 'amber', 'wood'],
    image: '/products/lavender-oud.webp' },

  { id: 'sugar-rouge', name: 'Sugar Rouge', category: 'Sweet & Warm',
    profile: 'Saffron, sugar, amber, woods, musk',
    description: 'Sweet amber warmth with saffron, airy woods and a smooth musky finish.',
    bestFor: 'Compliment scent, gifting, evening wear',
    featured: true, giftReady: true,
    notes: ['saffron', 'sugar', 'amber', 'wood', 'musk', 'sweet'],
    image: '/products/sugar-rouge.webp' },

  { id: 'ghost-oud', name: 'Ghost Oud', category: 'Signature Oud',
    profile: 'Oud, smoke, dry woods, amber, musk',
    description: 'A smoky oud with dry woods, amber warmth and a ghostly smooth finish.',
    bestFor: 'Bold oud lovers, night wear, strong impression',
    featured: false, giftReady: true,
    notes: ['oud', 'smoke', 'wood', 'amber', 'musk', 'bold'],
    image: '/products/ghost-oud.webp' },

  { id: 'african-oud', name: 'African Oud', category: 'Signature Oud',
    profile: 'Rich oud, earthy woods, amber, resin',
    description: 'Deep, earthy and resinous with a warm traditional oud character.',
    bestFor: 'Oud collectors, mature wear, formal occasions',
    featured: false, giftReady: true,
    notes: ['oud', 'earth', 'wood', 'amber', 'resin'],
    image: '/products/african-oud.webp' },

  { id: 'nightshade-mirage', name: 'Nightshade Mirage', category: 'Dark & Bold',
    profile: 'Dark fruit, spice, woods, amber, musk',
    description: 'Mysterious, dark and smooth with fruit, spice and warm woody amber.',
    bestFor: 'Night wear, bold presence, luxury evenings',
    featured: false, giftReady: true,
    notes: ['fruit', 'spice', 'wood', 'amber', 'musk', 'dark'],
    image: '/products/nightshade-mirage.webp' },
];

// Stable color seed for each product â†’ used by the CSS bottle placeholder.
export const productHue = (id) => {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % 360;
  return h;
};
